module.exports = __webpack_public_path__ + "img/right1.2fb8c97a.png";